module.exports = __webpack_public_path__ + "static/media/MOSIS Procedure Guidance 1116.4b4b852e.pdf";